import script from "./TotalCompaniesPdf.vue?vue&type=script&lang=js"
export * from "./TotalCompaniesPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__